import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Tooltip from 'antd/es/tooltip';
import Div from '../div';
const CharacterCounter = ({ charCount, charLimit, tooltip, }) => {
    return (_jsx(Div, { position: "absolute", style: {
            bottom: 8,
            right: 8,
            color: charCount > charLimit ? 'red' : 'gray',
            textAlign: 'right',
            pointerEvents: 'none',
        }, children: _jsx(Tooltip, { title: tooltip, children: _jsxs("span", { style: {
                    cursor: 'help',
                    color: charCount > charLimit ? 'red' : 'gray',
                    display: 'inline-block',
                    pointerEvents: 'auto',
                }, children: [charCount, "/", charLimit] }) }) }));
};
export default CharacterCounter;
